<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1)">
      <h2>
        X
      </h2>
    </div>
    <div id="modal-body" class="privacy-policy" v-html="privacy"></div>
  </div>
</template>

<script>
import Axios from 'axios';
export default {
  name: "Politics",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx"
    }
  },
  data(){
    return {
      privacy: null,  
    }
  },
  async mounted() {
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/privacidad/aviso')
    this.privacy = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";
        }`,'')
    //console.log('privacy', this.privacy)
  }
};
</script>
<style lang="scss" >
.container {
  padding-top: 0vw;
  @media screen and (max-width: 768px) {
    padding-top: 13vw;
  }
}
.goBackBtn {
  display: flex;
  flex-direction: row;
  width: 80px;
  background-color: transparent;
  border: none;
  font-family: 'DINRegular' !important;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  color: #9E895C;
  h2 {
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}
.privacy-policy {
  font-family: 'DINRegular' !important;
  font-size: 1.3vw !important;
  margin-right: 4.2pt !important;
  margin-left: 4.2pt !important;
  text-align: justify;
  padding-inline: 2vw;
  margin-top: 7vw !important;
  h2 {
    margin-bottom: 2vw !important;
  }
  h3, p{
    margin: 0;
    margin-bottom: .5pt !important;
  }
  @media (max-width: 768px) {
    font-size: 4.9vw !important;
    a { 
      overflow: hidden;
      display: flex;
    }
  }
  *{
  font-family: 'DINRegular' !important;
  font-size: 1.3vw !important;
  @media (max-width: 768px) {
    font-size: 4.9vw !important;
  }
  }
}
</style>
